var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1229 446",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "14-blue-new") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "14-blue-new",
    transform: "translate(8.000000, 8.000000)",
    stroke: "#305B86"
  }, /*#__PURE__*/React.createElement("g", {
    id: "log_file",
    transform: "translate(-0.000000, 3.205308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "square_0001_DL(1)",
    fill: "#F8F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4857113,17.2929949 C83.4924068,22.3055981 139.203931,20.9191418 193.620284,13.1336244 C275.244814,1.45534915 363.298765,-13.0611217 363.298765,22.15631 C363.298765,57.3737417 363.298765,80.5642902 363.298765,106.006244 C363.298765,131.4482 363.298765,279.534137 363.298765,303.316604 C363.298765,327.099072 363.298765,369.231035 363.298765,388.02447 C363.298765,406.817905 354.180381,406.817905 331.012456,406.817905 C307.84453,406.817905 47.9172614,430.499841 17.4093027,406.817905 C-13.0986543,383.135968 5.7687974,158.761481 5.7687974,137.57923 C5.7687974,116.396979 5.7687974,93.4056571 5.7687974,77.4344084",
    id: "square_0001"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.898631, 79.894430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.898631, 125.964784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.898631, 172.035139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.742338, 218.105493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.742338, 264.175847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.742338, 310.246202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  }))), /*#__PURE__*/React.createElement("g", {
    id: "log_file",
    transform: "translate(155.128395, 1.409928)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "square_0001_DL(1)",
    fill: "#F8F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4857113,17.2929949 C83.4924068,22.3055981 139.203931,20.9191418 193.620284,13.1336244 C275.244814,1.45534915 363.298765,-13.0611217 363.298765,22.15631 C363.298765,57.3737417 363.298765,80.5642902 363.298765,106.006244 C363.298765,131.4482 363.298765,279.534137 363.298765,303.316604 C363.298765,327.099072 363.298765,369.231035 363.298765,388.02447 C363.298765,406.817905 354.180381,406.817905 331.012456,406.817905 C307.84453,406.817905 47.9172614,430.499841 17.4093027,406.817905 C-13.0986543,383.135968 5.7687974,158.761481 5.7687974,137.57923 C5.7687974,116.396979 5.7687974,93.4056571 5.7687974,77.4344084",
    id: "square_0001"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.898631, 79.894430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.898631, 125.964784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.898631, 172.035139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.742338, 218.105493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.742338, 264.175847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.742338, 310.246202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  }))), /*#__PURE__*/React.createElement("g", {
    id: "log_file",
    transform: "translate(300.260082, 1.131032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "square_0001_DL(1)",
    fill: "#F8F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4857113,17.2929949 C83.4924068,22.3055981 139.203931,20.9191418 193.620284,13.1336244 C275.244814,1.45534915 363.298765,-13.0611217 363.298765,22.15631 C363.298765,57.3737417 363.298765,80.5642902 363.298765,106.006244 C363.298765,131.4482 363.298765,279.534137 363.298765,303.316604 C363.298765,327.099072 363.298765,369.231035 363.298765,388.02447 C363.298765,406.817905 354.180381,406.817905 331.012456,406.817905 C307.84453,406.817905 47.9172614,430.499841 17.4093027,406.817905 C-13.0986543,383.135968 5.7687974,158.761481 5.7687974,137.57923 C5.7687974,116.396979 5.7687974,93.4056571 5.7687974,77.4344084",
    id: "square_0001"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.898631, 79.894430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.898631, 125.964784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.898631, 172.035139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.742338, 218.105493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.742338, 264.175847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.742338, 310.246202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  }))), /*#__PURE__*/React.createElement("g", {
    id: "log_file",
    transform: "translate(747.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "square_0001_DL(1)",
    fill: "#F8F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4857113,17.2929949 C83.4924068,22.3055981 139.203931,20.9191418 193.620284,13.1336244 C275.244814,1.45534915 363.298765,-13.0611217 363.298765,22.15631 C363.298765,57.3737417 363.298765,80.5642902 363.298765,106.006244 C363.298765,131.4482 363.298765,279.534137 363.298765,303.316604 C363.298765,327.099072 363.298765,369.231035 363.298765,388.02447 C363.298765,406.817905 354.180381,406.817905 331.012456,406.817905 C307.84453,406.817905 47.9172614,430.499841 17.4093027,406.817905 C-13.0986543,383.135968 5.7687974,158.761481 5.7687974,137.57923 C5.7687974,116.396979 5.7687974,93.4056571 5.7687974,77.4344084",
    id: "square_0001"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.898631, 79.894430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.898631, 125.964784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.898631, 172.035139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.742338, 218.105493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.742338, 264.175847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.742338, 310.246202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  }))), /*#__PURE__*/React.createElement("g", {
    id: "log_file",
    transform: "translate(661.617284, 6.108773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "square_0001_DL(1)",
    fill: "#F8F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4857113,17.2929949 C83.4924068,22.3055981 139.203931,20.9191418 193.620284,13.1336244 C275.244814,1.45534915 363.298765,-13.0611217 363.298765,22.15631 C363.298765,57.3737417 363.298765,80.5642902 363.298765,106.006244 C363.298765,131.4482 363.298765,279.534137 363.298765,303.316604 C363.298765,327.099072 363.298765,369.231035 363.298765,388.02447 C363.298765,406.817905 354.180381,406.817905 331.012456,406.817905 C307.84453,406.817905 47.9172614,430.499841 17.4093027,406.817905 C-13.0986543,383.135968 5.7687974,158.761481 5.7687974,137.57923 C5.7687974,116.396979 5.7687974,93.4056571 5.7687974,77.4344084",
    id: "square_0001"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.898631, 79.894430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.898631, 125.964784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.898631, 172.035139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.742338, 218.105493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.742338, 264.175847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.742338, 310.246202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  }))), /*#__PURE__*/React.createElement("g", {
    id: "log_file",
    transform: "translate(562.494650, 1.131032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "square_0001_DL(1)",
    fill: "#F8F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4857113,17.2929949 C83.4924068,22.3055981 139.203931,20.9191418 193.620284,13.1336244 C275.244814,1.45534915 363.298765,-13.0611217 363.298765,22.15631 C363.298765,57.3737417 363.298765,80.5642902 363.298765,106.006244 C363.298765,131.4482 363.298765,279.534137 363.298765,303.316604 C363.298765,327.099072 363.298765,369.231035 363.298765,388.02447 C363.298765,406.817905 354.180381,406.817905 331.012456,406.817905 C307.84453,406.817905 47.9172614,430.499841 17.4093027,406.817905 C-13.0986543,383.135968 5.7687974,158.761481 5.7687974,137.57923 C5.7687974,116.396979 5.7687974,93.4056571 5.7687974,77.4344084",
    id: "square_0001"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.898631, 79.894430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.898631, 125.964784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.898631, 172.035139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.742338, 218.105493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.742338, 264.175847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.742338, 310.246202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  }))), /*#__PURE__*/React.createElement("g", {
    id: "log_file",
    transform: "translate(449.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "square_0001_DL(1)",
    fill: "#F8F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4857113,17.2929949 C83.4924068,22.3055981 139.203931,20.9191418 193.620284,13.1336244 C275.244814,1.45534915 363.298765,-13.0611217 363.298765,22.15631 C363.298765,57.3737417 363.298765,80.5642902 363.298765,106.006244 C363.298765,131.4482 363.298765,279.534137 363.298765,303.316604 C363.298765,327.099072 363.298765,369.231035 363.298765,388.02447 C363.298765,406.817905 354.180381,406.817905 331.012456,406.817905 C307.84453,406.817905 47.9172614,430.499841 17.4093027,406.817905 C-13.0986543,383.135968 5.7687974,158.761481 5.7687974,137.57923 C5.7687974,116.396979 5.7687974,93.4056571 5.7687974,77.4344084",
    id: "square_0001"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.898631, 79.894430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.898631, 125.964784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.898631, 172.035139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.742338, 218.105493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.742338, 264.175847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "line_item",
    transform: "translate(58.742338, 310.246202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.170725406,3.32854822 C0.170725406,6.58647367 -0.213406758,9.86710473 0.170725406,13.1023246 C1.81655807,26.9637789 0.990921519,25.1005491 15.5672846,23.830305 C17.0369576,23.7022317 19.094325,23.6666804 19.7334926,22.3376572 C20.7694551,20.1835769 20.1113553,17.5275163 19.7334926,15.1674949 C17.5024059,1.23277104 15.0746001,-3.72134068 1.61628366,2.91278786 L0.170725406,3.32854822 Z",
    id: "Path-6",
    fill: "#305B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0079533,13.756636 C64.5472498,13.756636 86.2963357,9.51782724 108.132926,9.76217754 C156.344069,10.3016577 202.374524,19.6805925 252.227581,15.5832552",
    id: "Path-9",
    strokeWidth: 16
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.7b6e49010000ea80937091d5475f3d16.svg";
export { ForwardRef as ReactComponent };